import React, { useState, useEffect } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import CheckSharpIcon from '@mui/icons-material/CheckSharp';
import { Typography } from '@mui/material'
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import TripleToggleButton from '../ui/ToggleButton/TripleToggleButton';
import RadioButton from '../ui/Radio/Radio';
import CustomButton from '../ui/Button';
import CustomIconButton from '../ui/IconButton';

interface Player {
    id: number;
    name: string;
}

interface Team {
    id: number;
    name: string;
}

interface FilterOptions {
    homeTeam: string;
    matchLabel: string;
    matchStatus: string;
    selectedOption: string;
}

interface PlayersProps {
    onCloseDrawer: () => void;
    onFilterChange: (filterName: string, value: string | boolean) => any;
    selectedFilters: FilterOptions;
}

const teamLabels = [
    { key: 'ALL', value: 'ALL' },
    { key: 'HOME', value: 'HOME' },
    { key: 'AWAY', value: 'AWAY' }
];

const Players: React.FC<PlayersProps> = ({ onCloseDrawer, onFilterChange, selectedFilters }) => {   

    const handleTeamLabelsChange = (selectedLabel: { key: string }) => {
        onFilterChange('TeamLabel', selectedLabel.key);
    };

    const handleOptionClick = (option: string) => {
        onFilterChange('selectedOption', option);
    };
    
    return (
        <div className='last-matches-modal'>
            <div className='modal-header'>
                <h5>PLAYERS</h5>
                <CustomIconButton onClick={onCloseDrawer}>
                    <HighlightOffIcon />
                </CustomIconButton>
            </div>
            <div className='team-details'>
                <div className='player-team-logo'>
                    <img src="https://cdn5.wyscout.com/photos/team/public/786_120x120.png" alt="Icon" />
                </div>
                <div className='model-body'>
                    <div className="modal-inner-wrapper">
                        <span>TEAMS</span>
                        <div className='leeds-opposition'>
                            <div className='team-comparision'>
                                <Typography>LEEDS</Typography>
                                <Typography>VS</Typography>
                                <Typography>OPPOSITION</Typography>
                            </div>
                            <div className='team-label-wrappe'>
                                <TripleToggleButton
                                    labels={teamLabels}
                                    defaultLabelKey={selectedFilters.matchLabel}
                                    onChange={handleTeamLabelsChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='model-body'>
                <div className="modal-inner-wrapper">
                    <span>PLAYERS VISIBLE</span>
                    <List>
                        <ListItem style={{ border: '1px solid GrayText', marginBottom: '20px' }}>
                            <RadioButton
                                selected={selectedFilters.selectedOption === 'FORMATION A'}
                                onChange={() => handleOptionClick('FORMATION A')}
                                label="FORMATION A"
                            />
                            <ListItemText primary="FORMATION A" />
                            <Typography>Created: David N</Typography>
                            <Typography>Last Edited 23.09.24</Typography>
                        </ListItem>

                        <ListItem
                            style={{ border: '1px solid GrayText', marginBottom: '20px' }}>
                            <RadioButton
                                selected={selectedFilters.selectedOption === 'FORMATION B'}
                                onChange={() => handleOptionClick('FORMATION B')}
                                label="FORMATION B"
                            />
                            <ListItemText primary="FORMATION B" />
                            <Typography>Created: David N</Typography>
                            <Typography>Last Edited 23.09.24</Typography>
                        </ListItem>
                        <ListItem style={{ border: '1px solid GrayText', marginBottom: '20px' }}>
                            <RadioButton
                                selected={selectedFilters.selectedOption === 'CUP TEAM A'}
                                onChange={() => handleOptionClick('CUP TEAM A')}
                                label="CUP TEAM A"
                            />
                            <ListItemText primary="CUP TEAM A" />
                            <Typography>Created: David N</Typography>
                            <Typography>Last Edited 23.09.24</Typography>
                        </ListItem>
                        <ListItem style={{ border: '1px solid GrayText', marginBottom: '20px' }}>
                            <RadioButton
                                selected={selectedFilters.selectedOption === 'ALL'}
                                onChange={() => handleOptionClick('ALL')}
                                label="ALL"
                            />
                            <ListItemText primary="ALL" />
                            <Typography>Default</Typography>
                        </ListItem>
                        <ListItem style={{ border: '1px solid GrayText', marginBottom: '20px' }}>
                            <RadioButton
                                selected={selectedFilters.selectedOption === 'HEAVILY FEATURED'}
                                onChange={() => handleOptionClick('HEAVILY FEATURED')}
                                label="ALL"
                            />
                            <ListItemText primary="HEAVILY FEATURED" />
                            <Typography>Default</Typography>
                        </ListItem>
                    </List>
                </div>
            </div>
            <div className="modal-footer">
                <CustomButton
                    startIcon={<CheckSharpIcon />}
                    onClick={onCloseDrawer}>
                    CONFIRM
                </CustomButton>
            </div>
        </div>
    )
}

export default Players